const pages = {
  gallery: {
    eyebrow: 'Utrinki',
    title: 'Galerija',
    intro: 'Fotografije iz Črne Kuhne — ogenj, jedi, prostor in vino. Dodajamo jih sproti, ko jih posnamemo.',
    ctaTitle: 'Pridite za skupno mizo',
    ctaText: 'Galerija ti da občutek, a vonj po ognju in okus po Prlekiji doživiš le v živo. Rezerviraj mizo in pridi.',
    filters: { all: 'Vse', fire: 'Ogenj', dishes: 'Z jedilnika', space: 'Prostor', wine: 'Vino' },
    categories: { fire: 'Ogenj', dishes: 'Z jedilnika', space: 'Prostor', wine: 'Vino' },
    empty: 'V tej kategoriji še ni fotografij.',
    openLabel: 'Odpri fotografijo',
    closeLabel: 'Zapri',
    prevLabel: 'Prejšnja',
    nextLabel: 'Naslednja',
    photos: {
      oven: 'Krušna peč z ognjem — srce naše kuhinje',
      grill: 'Žar z odprtim ognjem',
      carpaccio: 'Karpačo iz postrvi s svežimi breskvami',
      soupNoodles: 'Domača juha z rezanci',
      pumpkinSoup: 'Kremna bučna juha z bučnim oljem',
      tomahawk: 'Tomahawk steak s prilogo z žara',
      dessert: 'Domača sladica',
      preparation: 'Priprava jedi v kuhinji',
      chandelier: 'Detajl prostora — lestenec iz zelenih steklenic',
      interior: 'Notranjost Črne Kuhne',
      wine: 'Steklenica Traminca iz kleti Glavinič',
      team: 'Ekipa Črne Kuhne v restavraciji',
      host: 'Gostitelj Črne Kuhne pred jedmi iz naše kuhinje',
    },
    captions: {
      preparation: 'Na posebnih kulinaričnih večerih se nam pridružijo najboljši kuharji Slovenije.',
    },
  },
  menu: {
    eyebrow: 'Jedilnik',
    title: 'Sezonski jedilnik',
    intro: 'Kuhinja sledi letnim časom in prleški zemlji. Jedi se skozi leto spreminjajo, zato jedilnika ne posodabljamo vnaprej na pamet.',
    seasonalNotice: 'Sezonski jedilnik se spreminja',
    seasonalNoticeText: 'Aktualno ponudbo preverite po telefonu — z veseljem vam povemo, kaj je ta dan na mizi.',
    emptyTitle: 'Jedilnik pripravljamo',
    emptyText: 'Ponudba se objavi, ko je potrjena. Do takrat vas z veseljem usmerimo po telefonu.',
    allergensTitle: 'Alergeni in prehranske možnosti',
    allergensText: 'Ob jedeh navedemo alergene. Povejte nam o alergijah in prehranskih omejitvah, da jed pripravimo po vaši meri.',
    dietaryText: 'Za vegetarijanske, brezglutenske in druge prilagoditve se dogovorimo vnaprej.',
    pdfTitle: 'Jedilnik v PDF',
    pdfText: 'Povezava do PDF jedilnika bo dodana, ko nam jo posredujete.',
    ctaCall: 'Pokliči za aktualno ponudbo',
    categoriesLabel: 'Kategorije',
    loading: 'Nalaganje jedilnika …',
    error: 'Jedilnika trenutno ni mogoče naložiti.',
    retry: 'Poskusi znova',
  },
  reserve: {
    eyebrow: 'Rezervacija',
    title: 'Črna Kuhna',
    intro: 'Izberite datum, uro in število oseb. Rezervacijo lahko uredite tudi po telefonu ali e-pošti.',
    bookingTitle: 'Rezervacijski sistem',
    bookingText: 'Rezervacije potekajo prek spletnega rezervacijskega sistema. Če vam splet ne ustreza, nas pokličite ali nam pišite.',
    bookingPending: 'Rezervacijski sistem je v pripravi. Do takrat mizo rezervirajte po telefonu ali e-pošti.',
    bookingAreaLabel: 'Tu bo vgrajen rezervacijski sistem',
    phoneTitle: 'Po telefonu',
    phoneText: 'Najhitreje se dogovorimo — pokličite nas in rezervirali bomo mizo.',
    emailTitle: 'Po e-pošti',
    emailText: 'Napišite datum, uro in število oseb, pa vam potrdimo rezervacijo.',
    infoTitle: 'Dobro je vedeti',
    infoItems: [
      'Večje skupine prosimo, da rezervacijo najavijo vnaprej.',
      'O alergijah in prehranskih omejitvah nas obvestite ob rezervaciji.',
      'Za posebne priložnosti se dogovorimo vnaprej, da pripravimo vse potrebno.',
    ],
    groupText: 'Načrtujete zasebno večerjo ali večjo skupino?',
    formTitle: 'Rezervirajte mizo',
    formIntro: 'Izberite datum, uro in število oseb ter vnesite svoje podatke. Rezervacijo vam potrdimo v najkrajšem možnem času.',
    formName: 'Ime in priimek',
    formPhone: 'Telefon',
    formEmail: 'E-pošta (neobvezno)',
    formDate: 'Datum',
    formTime: 'Ura',
    formTimePlaceholder: 'Izberite uro',
    formGuests: 'Število oseb',
    formGuestsUnit: 'oseb',
    formNotes: 'Opomba (neobvezno)',
    formNotesPlaceholder: 'Posebne želje, alergije, priložnost …',
    formSubmit: 'Rezerviraj mizo',
    formSending: 'Pošiljam …',
    formSuccessTitle: 'Rezervacija poslana!',
    formSuccessText: 'Hvala! Vašo rezervacijo smo prejeli. Potrditev prejmete po telefonu ali e-pošti v najkrajšem možnem času.',
    formAnother: 'Nova rezervacija',
    formError: 'Rezervacije ni bilo mogoče poslati. Poskusite znova ali nas pokličite.',
    formRequired: 'Prosimo, izpolnite ime, telefon, datum, uro in število oseb.',
    formCharCount: 'največ 500 znakov',
  },
  story: {
    eyebrow: 'Zgodba',
    title: 'Naša zgodba',
    intro: 'Črna Kuhna je zrasla iz ognja, prleške zemlje in želje po skupni mizi.',
    lead: 'V Črni Kuhni na Vinskem Vrhu se vse začne pri ognju v domači krušni peči. Iz sezonskih sestavin z naše kmetije in od prleških dobaviteljev pripravljamo jedi, ob katerih ponudimo hišna vina Glavinič. Pridite, sedite za mizo in okusite Prlekijo.',
    fireTitle: 'Ogenj kot izhodišče',
    fireText: 'Kuhanje se pri nas začne pri ognju. Krušna peč ni kulisa, ampak srce kuhinje — v njej se jedi pečejo počasi, z občutkom za toplino in čas.',
    firePhotoLabel: 'Fotografija — krušna peč z ognjem',
    localTitle: 'Zemlja in letni časi',
    localText: 'Naša usmeritev je slediti letnim časom in prleški zemlji ter sodelovati z lokalnimi pridelovalci in vinarji.',
    valuesTitle: 'Kaj nam je pomembno',
    values: [
      'Povemo natanko, kaj je na krožniku — brez izmišljotin.',
      'Spoštujemo sezono in ne obljubljamo, česar ni.',
      'Miza je skupna: prostor za pogovor, kozarec in čas.',
    ],
    chaptersLabel: 'Poglavja',
    chaptersTitle: 'Raziščite našo zgodbo',
    chaptersText: 'Kliknite poglavje in odprlo se bo — slika in beseda se prikažeta kot iz ognja.',
    chaptersHint: 'Klikni za odpiranje',
  },
  wines: {
    eyebrow: 'Vina',
    title: 'Vina in Vinski raj Glavinič',
    intro: 'Hišna vina prihajajo iz prleških vinogradov, kjer vino raste tik ob jedi.',
    houseTitle: 'Hišna vina Glavinič',
    houseText: 'Ob jedi gostimo hišna vina Glavinič. Za usklajevanje vina in jedi se pogovorimo in vam priporočimo kozarec, ki se poda k vašemu obroku.',
    tastingTitle: 'Pokušine',
    tastingText: 'O pokušinah in vodenih degustacijah se dogovorimo vnaprej. Povežemo jih lahko tudi s hrano iz krušne peči.',
    externalTitle: 'Vinogradništvo Glavinič',
    externalText: 'Za več o vinarstvu Glavinič poglejte njihove lastne strani ali jih poiščite na spletu.',
    externalCta: 'Poišči Vinski raj Glavinič',
    photoLabel: 'Fotografija — vino, kozarci ali vinogradi',
    listTitle: 'Vinska karta',
    listIntro: 'Izbor vin iz prleških kleti, ki se poda k naši kuhinji.',
    whiteTitle: 'Bela vina',
    redTitle: 'Rdeča vina',
    wineryLabel: 'Vinar',
  },
  visit: {
    eyebrow: 'Obisk',
    title: 'Obisk in kontakt',
    intro: 'Najdete nas sredi prleških gričev in vinogradov. Gumb spodaj odpre navigacijo do nas.',
    regionBadge: 'Jeruzalemske gorice',
    regionTitle: 'V srcu jeruzalemskih goric',
    regionText: 'Naša kuhinja stoji v jeruzalemski vinski regiji — med vinogradi Jeruzalemskih goric, tik nad Miklavžem pri Ormožu. Tu sta vino in jed doma.',
    addressTitle: 'Naslov',
    mapTitle: 'Zemljevid',
    directionsCta: 'Odpri navigacijo',
    phoneTitle: 'Telefon',
    emailTitle: 'E-pošta',
    hoursTitle: 'Zimski delovni čas',
    hoursText: 'Odprto od četrtka do nedelje; ponedeljek–sreda zaprto.',
    socialTitle: 'Družbena omrežja',
    socialText: 'Povezavo do Instagrama dodamo, ko jo posredujete.',
    groupText: 'Za večje skupine in zasebne priložnosti nas pokličite.',
  },
  events: {
    eyebrow: 'Dogodki',
    title: 'Dogodki in zasebne večerje',
    intro: 'Za zasebne večerje, družinska praznovanja in poslovna srečanja pripravimo mizo po meri vaše priložnosti.',
    typesTitle: 'Kaj lahko načrtujemo',
    types: [
      'Zasebne večerje ob ognju',
      'Družinska praznovanja in obletnice',
      'Poslovna srečanja in zaključene skupine',
      'Degustacije z usklajevanjem vin',
    ],
    enquiryTitle: 'Povpraševanje',
    enquiryText: 'Napišite nam, kaj načrtujete, in odgovorili vam bomo s predlogom in podrobnostmi.',
    formName: 'Ime in priimek',
    formEmail: 'E-pošta',
    formPhone: 'Telefon',
    formType: 'Vrsta dogodka',
    formTypeOptions: ['Zasebna večerja', 'Družinsko praznovanje', 'Poslovno srečanje', 'Degustacija', 'Drugo'],
    formDate: 'Okvirni datum',
    formGuests: 'Število oseb',
    formMessage: 'Sporočilo',
    formMessagePlaceholder: 'Opišite priložnost, želje in morebitne posebnosti …',
    formSubmit: 'Pošlji povpraševanje',
    formSending: 'Pošiljanje …',
    formSuccess: 'Hvala! Povpraševanje je poslano — odgovorili vam bomo v najkrajšem možnem času.',
    formError: 'Povpraševanja ni bilo mogoče poslati. Poskusite znova ali nas pokličite.',
    formRequired: 'Prosimo, izpolnite obvezna polja.',
    formCharCount: 'največ 500 znakov',
  },
  gift: {
    eyebrow: 'Darilo',
    title: 'Darilni boni',
    intro: 'Podarite obrok v Črni Kuhni — za praznovanje, zahvalo ali preprosto veselje.',
    howTitle: 'Kako do darilnega bona',
    howText: 'Darilni bon uredimo po telefonu ali e-pošti. Povemo vam, kaj je v tem trenutku mogoče, in se dogovorimo za izdajo.',
    valueTitle: 'Vrednost in veljavnost',
    valueText: 'Vrednost in veljavnost bona dogovorimo ob nakupu, tako da ustrezata vaši želji.',
    ctaTitle: 'Naročite darilni bon',
    ctaText: 'Pokličite nas ali nam pišite in pripravili bomo bon po vaši želji.',
    photoLabel: 'Fotografija — darilni bon oziroma miza',
    vouchersTitle: 'Darilni bon v vrednosti 50 € ali 100 €',
    vouchersText: 'Izbira je preprosta. Darilni bon lahko kupite kar v restavraciji na točilnem pultu in ga nato lepo podarite naprej — za praznovanje, zahvalo ali preprosto veselje.',
    voucherName: 'Darilni bon',
    voucherBuyLabel: 'Na voljo na točilnem pultu v restavraciji',
    voucherBuyNote: 'Bon prejmete takoj, ko ga kupite na točilnem pultu. Primeren je za vse jedi in pijače iz naše ponudbe.',
  },
  privacy: {
    eyebrow: 'Pravno',
    title: 'Politika zasebnosti',
    intro: 'Vaše podatke uporabljamo le za namen, za katerega ste nam jih zaupali.',
    sections: [
      { title: 'Katere podatke zbiramo', body: 'Podatke, ki jih vnesete v obrazce na naši strani (na primer ime, e-pošta, telefon in vsebina sporočila), ter podatke, ki jih posredujete ob rezervaciji ali povpraševanju.' },
      { title: 'Zakaj jih uporabljamo', body: 'Podatke uporabljamo za odgovor na vaše povpraševanje, za izvedbo rezervacije in za komunikacijo v zvezi z vašim obiskom.' },
      { title: 'Hramba in varnost', body: 'Podatke hranimo le toliko časa, kolikor je potrebno za namen, za katerega so bili zbrani, in jih varujemo pred nepooblaščenim dostopom.' },
      { title: 'Vaše pravice', body: 'Imate pravico do vpogleda, popravka in izbrisa svojih podatkov ter do ugovora obdelavi. Za uveljavljanje pravic nas kontaktirajte.' },
      { title: 'Piškotki', body: 'Stran uporablja le nujno potrebne tehnologije za delovanje in shranjevanje vaše izbire jezika.' },
    ],
    contactNote: 'Za vprašanja o zasebnosti nas kontaktirajte:',
  },
  terms: {
    eyebrow: 'Pravno',
    title: 'Pogoji uporabe',
    intro: 'Z uporabo te strani se strinjate z naslednjimi pogoji.',
    sections: [
      { title: 'Vsebina strani', body: 'Vsebina je objavljena v dobri veri in se lahko spremeni. Jedilnik, delovni čas in ponudba se spreminjajo; aktualne informacije preverite pri nas.' },
      { title: 'Rezervacije', body: 'Rezervacija velja, ko je potrjena. Prosimo, da nas ob spremembi ali odpovedi obvestite čim prej.' },
      { title: 'Zunanje povezave', body: 'Na strani so lahko povezave na zunanje strani, za katerih vsebino ne odgovarjamo.' },
      { title: 'Avtorske pravice', body: 'Vsebina in podoba strani sta zaščiteni. Uporaba brez dovoljenja ni dovoljena.' },
    ],
    contactNote: 'Za vprašanja nas kontaktirajte:',
  },
};

export default { pages };